interface UploadedFileNameProps {
  name: string | null;
  iconClass?: string;
  onRemove?: () => void;
}

export default function UploadedFileName({ name, iconClass = "ri-file-line", onRemove }: UploadedFileNameProps) {
  if (!name) return null;

  return (
    <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-gray-50 border border-gray-100 text-xs text-gray-600">
      <i className={`${iconClass} text-base shrink-0 text-[#1977cc]`} />
      <span className="flex-1 truncate" title={name}>{name}</span>
      {onRemove && (
        <button
          type="button"
          onClick={onRemove}
          className="text-gray-400 hover:text-red-500 shrink-0 cursor-pointer"
          aria-label="파일 제거"
        >
          <i className="ri-close-line" />
        </button>
      )}
    </div>
  );
}
